import { SERVICE_ICONS } from "../constants";

function ListItemVisual({ config, item }) {
  const image = config.imageField && item[config.imageField];
  if (image) {
    return (
      <img
        src={image}
        alt=""
        className="size-14 shrink-0 rounded-md bg-neutral-100 object-cover"
      />
    );
  }
  const option = SERVICE_ICONS.find(
    (entry) => entry.value === item[config.iconField],
  );
  if (!option) return null;
  return (
    <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-sky-950 text-white">
      <option.Icon width={18} className="fill-current" />
    </span>
  );
}

export default ListItemVisual;
